import React, { ReactElement, ReactNode, useContext } from "react";
import { useI18n } from "i18n";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { Key02 as Key02Icon } from "@remo-co/ui-core/src/icons/Key02";
import { useStyles } from "./SAMLSSOButton.styles";
import { signInWithSAML } from "../utils/socialAuth";
import AuthButton from "./AuthButton";

interface ISAMLSSOButtonProps {
  providerName: string;
  children: ReactNode;
  isPreview?: boolean;
  isEventHappeningNow?: boolean; // only when used in event landing
}

const SAMLSSOButton = ({
  providerName,
  children,
  isPreview,
  isEventHappeningNow,
}: ISAMLSSOButtonProps): ReactElement => {
  const { track } = useContext(TRACKING_CONTEXT);
  const { t } = useI18n(["common", "auth"]);
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const handleAuth = async () => {
    if (isEventHappeningNow !== undefined) {
      track(Events.LOGIN_CLICKED_CUSTOM_SSO, {
        eventStatus: isEventHappeningNow ? "ongoing" : "upcoming",
      });
    }

    setIsLoading(true);
    await signInWithSAML(providerName, true);
    setIsLoading(false);
  };

  return (
    <AuthButton
      onClick={isPreview ? undefined : handleAuth}
      data-testid="saml-sso-button"
      startAdornment={<Key02Icon />}
      loading={isLoading}
      tabIndex={isPreview ? -1 : undefined}
      className={isPreview ? classes.isPreview : ""}
      variant="special"
    >
      {isLoading ? t("wait") : children}
    </AuthButton>
  );
};

export default SAMLSSOButton;
